import { useStripe } from "@stripe/react-stripe-js";
import React from "react";
import { errorHandler } from "../../../../store/actions/responseHandler";
import PaymentModal from "../StepSix/PaymentModal";

const PayModal = ({ isOpen, setIsOpen, onPayment, onPaymentSuccess }) => {
  const stripe = useStripe();

  return (
    <PaymentModal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      onPayment={() => {
        onPayment(data => {
          if (data && data.status === "requires_action") {
            stripe
              .confirmCardPayment(data?.client_secret, {
                payment_method: data?.payment_method,
              })
              .then(auth => {
                if (auth?.error) {
                  errorHandler(auth?.error?.message);
                  setIsOpen(false);
                } else {
                  onPaymentSuccess(() => setIsOpen(false));
                }
              })
              .catch(err => console.log("error: ", err));
          } else {
            setIsOpen(false);
          }
        });
      }}
      price="1"
      allowBankDebit={false}
      title="Personalise Experience"
    />
  );
};

export default PayModal;
